import { Button } from '@appsumo/dorado-react';
import { memo } from 'react';
import InformationBox from '~/components/ui/InformationBox';
import { DEAL_COMMENT_TYPE } from '~/lib/discussions/constants';
import { LOGIN_URL } from '~/lib/util/constants';

interface LoginToCommentProps {
  dealSlug: string;
  actionText: string;
  type: DEAL_COMMENT_TYPE;
}

function LoginToComment({
  dealSlug,
  actionText,
  type,
}: Readonly<LoginToCommentProps>) {
  let next = window?.location.pathname;

  if (type === DEAL_COMMENT_TYPE.REVIEW) {
    next = `/products/${dealSlug}/reviews/new/`;
  }

  return (
    <InformationBox
      text={`Log in to ${actionText}`}
      helpText="Only logged-in purchasers can review products on AppSumo."
    >
      <Button href={`${LOGIN_URL}?next=${next}`} tertiary>
        Log in
      </Button>
    </InformationBox>
  );
}

export default memo(LoginToComment);
